import {Component, effect, inject, signal} from '@angular/core';
import {rxResource} from "@angular/core/rxjs-interop";
import {PlanService} from "@api-services";
import {AuthenticationService} from "@services";
import {of} from "rxjs";
import {map} from "rxjs/operators";
import {PlanDto} from "@api-contracts";
import {TranslocoDirective} from "@jsverse/transloco";
import {CheckboxComponent, PaypalButtonComponent} from "@components";
import {CurrencyPipe} from "@angular/common";
import {FormsModule} from "@angular/forms";

@Component({
  selector: 'wun-subscription',
  standalone: true,
  imports: [
    TranslocoDirective,
    CheckboxComponent,
    CurrencyPipe,
    PaypalButtonComponent,
    FormsModule
  ],
  templateUrl: './subscription.component.html',
  styleUrl: './subscription.component.scss'
})
export class SubscriptionComponent {

  private readonly planService = inject(PlanService);
  private readonly authService = inject(AuthenticationService);

  plans = rxResource({
    params: () => this.authService.current(),
    stream: (d) => {
      if(!d) return of(new Array<PlanDto>());
      return this.planService.plansFindAndPaginate({
        filters: JSON.stringify({
          "productId": d.params.profileType === 'ARTIST' ? ['WUNDART_ARTIST', 'WUNDART_ARTIST_GOLD'] : ['WUNDART_GALLERY','WUNDART_GALLERY_GOLD']
        })
      }).pipe(map(d => d.data))
    }
  })
  currentPlan = signal('');
  hasSubscription = this.authService.hasSubscription;
  subscription = this.authService.subscription;

  constructor() {
    effect(() => {
      const me = this.authService.current();
      if(me?.subscription?.subscriptionId && me.subscription.kind === 'PAYPAL'){
        this.currentPlan.set(me.subscription.plan!.planId)
      }
    });
  }

  setCurrentPlan(plan: PlanDto) {
    if(this.hasSubscription()) return;
    this.currentPlan.set(plan.planId)
  }

  reloadMe() {
    this.authService.refreshMe()
  }
}
